import type { ButtonRect } from "../ui/layout";
export type QaBox = { x: number; y: number; w: number; h: number };
export const toBox = (r: ButtonRect | null): QaBox | null =>
  r ? { x: r.x, y: r.y, w: r.width, h: r.height } : null;
export function unionRects(rects: ButtonRect[]): ButtonRect | null {
  if (!rects.length) return null;
  const x = Math.min(...rects.map((r) => r.x)),
    y = Math.min(...rects.map((r) => r.y));
  return {
    x,
    y,
    width: Math.max(...rects.map((r) => r.x + r.width)) - x,
    height: Math.max(...rects.map((r) => r.y + r.height)) - y,
  };
}
export function scaledRect(r: ButtonRect, sx: number, sy = sx): ButtonRect {
  return {
    x: r.x + (r.width - r.width * sx) / 2,
    y: r.y + (r.height - r.height * sy) / 2,
    width: r.width * sx,
    height: r.height * sy,
  };
}
